// import Wrapper from "../assets/styles/form";
import "../assets/styles/sass/form.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Form = () => {
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const navigate = useNavigate();
	const handleRegisterUser = (e) => {
		e.preventDefault();
		if (name === "" || email === "" || password === "") {
			alert("Please fill all the fields");
		} else {
			axios
				.post("https://job-boarrd.herokuapp.com/registerUser", {
					name,
					email,
					password,
				})
				.then((res) => {
					console.log(res.data.user);
					setName("");
					setEmail("");
					setPassword("");
					setTimeout(() => {
						navigate("/careers");
					}, 2000);
				});

			console.log(name, email, password);
		}
	};

	return (
		<div className="form-body">
			<form onSubmit={handleRegisterUser}>
				<label>Name</label>
				<input
					type="text"
					name="name"
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>
				<label>Email</label>
				<input
					type="email"
					name="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
				<label>Password</label>
				<input
					type="password"
					name="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
				/>
				<button type="submit">Sign Up</button>
			</form>
		</div>
	);
};

export default Form;
